// extracted by mini-css-extract-plugin
module.exports = {"root":"trigger_root__KT9bT clickable_root__Sdo5n cursor-pointer inline-flex items-center justify-center leading-none pointer-events-auto text-center"};